import { useAuth } from 'contexts/AuthContext'
import Modal from 'components/Modal/Modal'
import React, { useState } from 'react'
import { DELETE } from 'api/request'
import * as url from 'api/urls'

interface DeleteUserModalProps {
  onClose: () => void
}

const DeleteUserModal: React.FC<DeleteUserModalProps> = ({ onClose }) => {
  const [sending, setSending] = useState<boolean>(false)
  const { logOut } = useAuth()

  const handleSubmit = async () => {
    setSending(true)
    try {
      const response = await DELETE(url.userDelete)
      if (response.ok) {
        onClose()
        logOut()
      }
      else {
        alert('nie zmieniono - response false')
      }
      setSending(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Modal
      onClose={onClose}
      title='Usuń konto'
      icon='trash'
      primaryDisabled={sending}
      primaryButton={sending ? 'Usuwanie...' : 'Usuń'}
      primaryButtonAction={handleSubmit}
      secondaryButton='Anuluj'
      secondaryButtonAction={'close'}>

        <p style={{textAlign: 'center'}}>Uswając konto stracisz wszystkie swoje tabliczki?? bezpowrotnie?</p>
    </Modal>
  )
}

export default DeleteUserModal